import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

function Breadcrumbs({ items }) {
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.link ? (
            <Link
              to={item.link}
              className="text-black hover:text-gray-500 transition-colors duration-200"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-500">{item.label}</span>
          )}
          {index < items.length - 1 && <FaChevronRight className="text-gray-400" />}
        </React.Fragment>
      ))}
    </nav>
  );
}

export default Breadcrumbs;
